// Import model
import { StartLeadAppointmentInitiateOmwsmsRequest } from '../models/StartLeadAppointmentInitiateOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentInitiateOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentInitiateOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentInitiateOmwsmsRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentInitiateOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentInitiateOmwsmsRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentInitiateOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentInitiateOmwsmsRequest');
    }


    const instance: StartLeadAppointmentInitiateOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentInitiateOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentInitiateOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentInitiateOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentInitiateOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentInitiateOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentInitiateOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentInitiateOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentInitiateOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
